const groupVpsHostingRequestToResponseFields = (fields) => {
  const introFields = fields.filter((field) => field.key === 'title');
  const stepGroups = [];

  for (let index = 1; index <= 20; index += 1) {
    const groupFields = fields
      .filter((field) => field.key.startsWith(`step-${index}-`))
      .sort((a, b) => a.sortOrder - b.sortOrder);

    if (!groupFields.some((field) => field.key === `step-${index}-title`)) {
      break;
    }

    stepGroups.push({ index, fields: groupFields });
  }

  return { introFields, stepGroups };
};

export default groupVpsHostingRequestToResponseFields;
